import ServerApi from '../commons/src/ServerApi'

export const serverApi = ServerApi(
  (data, init) => global.fetch(data, init),
  'https://test-a3f98.uc.r.appspot.com/',
)
